import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { DamagedItemsListItem } from "../../inventory.types";
import { requestGetDamagedItems } from "./getDamagedItems.request";

const useGetDamagedItemsList = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<DamagedItemsListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["inventory-manager-admin", "all-damaged-items", requestParams],
    queryFn: async () => await requestGetDamagedItems(requestParams),
    onError: toastServerError,
    ...options
  });

  return { damagedItemsList: data?.data, meta: data?.meta, ...rest };
};

export default useGetDamagedItemsList;
